import { create } from 'zustand';
import { IExportState, PosterType, StateType } from '@/version-types';
import { getState, useState } from '../index';

/** 存储类型 */
interface IStore {
    /** 主题 */
    theme: string;
    /** 海报类型 */
    posterType: PosterType;
    /**
     * 是否显示上下文菜单
     * 从旧版 isContextMenu 迁移
     */
    showContextMenu: boolean;
    /** 设置主题 */
    setTheme(theme: string): void;
    /** 设置海报类型 */
    setPosterType(posterType: PosterType): void;
    /**
     * 设置是否显示上下文菜单
     * 从旧版 setIsContextMenu 迁移
     */
    setShowContextMenu(showContextMenu: boolean): void;
    /** 销毁 */
    destroy: () => void;
}

/** 创建存储 */
const createState = () => {
    return create<IStore>((set) => ({
        destroy() {
            set({
                showContextMenu: false,
            });
        },

        theme: '',
        setTheme(theme: string) {
            set({ theme });
        },

        posterType: PosterType.Poster,
        setPosterType(posterType: PosterType) {
            set({ posterType });
        },

        showContextMenu: false,
        setShowContextMenu(showContextMenu: boolean) {
            set({ showContextMenu });
        },
    }));
};

/** 存储名称 */
const name = 'editor-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取 id */
export const useEditorState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getEditorState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

/** 导出存储 */
export default {
    name,
    createState,
} as IExportState;
